import { useQuery } from 'react-query';
import { Dayjs } from 'dayjs';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { appendQueryParamIfNotEmpty, formatDate, generateQueryKey } from '../../../constants/hookConstants';

export const useGetProfitableUnprofitableGraph = (
  identifier: string,
  from: Dayjs | null,
  to: Dayjs | null,
  interval: 'day' | 'week' | 'month',
  trackingSourceId: number,
) => {
  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(to));
  appendQueryParamIfNotEmpty(queryParams, 'interval', interval);
  appendQueryParamIfNotEmpty(queryParams, 'identifier', identifier);
  appendQueryParamIfNotEmpty(queryParams, 'trackingSourceId', trackingSourceId);

  const queryKey = generateQueryKey(interval, queryParams);

  return useQuery(
    [`reports_${queryKey}`],
    () => dataFetch.get(`${CORE_API_SUFFIX}ad/profitability-percentage?${queryParams}`).then((res) => res.data),
  );
};
